var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3911 20.6511C24.9541 20.6511 26.5171 20.3158 27.5007 19.994C27.7567 19.9001 27.9184 19.8599 28.0936 19.8599C28.4709 19.8599 28.8616 20.1683 28.8616 20.6511C28.8616 20.7852 28.8212 21.0936 28.7134 21.402C27.0965 25.5724 22.3536 28.8577 16.883 28.8577C9.41834 28.8577 3.71875 23.5341 3.71875 16.0784C3.71875 10.7683 6.88519 5.73968 11.6012 3.86235C11.8976 3.74166 12.2075 3.71484 12.3692 3.71484C12.8677 3.71484 13.1372 4.10372 13.1372 4.45237C13.1372 4.58646 13.1103 4.78761 12.9755 5.09602C12.5174 6.14197 12.1805 8.13999 12.1805 9.57481C12.1805 16.3868 16.5462 20.6511 23.3911 20.6511Z",
    fill: "#908CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkMode);
export default __webpack_public_path__ + "static/media/icon-dark-mode.c21de6a59a33fe4d21dca01d1a5beae2.svg";
export { ForwardRef as ReactComponent };